'use strict';

module.exports = function (ngModule) {
    ngModule.directive('qrCode', require('./qrcode'));
}


/** WEBPACK FOOTER **
 ** ./src/pages/directives/qrcode/index.js
 **/